module.exports = __webpack_public_path__ + "static/5-e365091c84f3fec279954c7ee36a8c55.png";